export default __webpack_public_path__ + "static/media/google-cloud-platform.e0353f44.svg";